export const ADD_ROW = 'ADD_ROW';
export const ERROR = 'ERROR';
export const LOAD_LIST = 'LOAD_LIST';
export const LOAD_OBJ = 'LOAD_OBJ';
export const SET_SELECTED = 'SET_SELECTED';
export const INIT = 'INIT';
export const REMOVE = 'REMOVE';
export const REFRESH = 'REFRESH';
export const COMMIT_NEW = 'COMMIT_NEW';

export const ADD_EMAIL = 'ADD_EMAIL';
export const ADD_PHONE = 'ADD_PHONE';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const REMOVE_EMAIL = 'REMOVE_EMAIL';
export const REMOVE_PHONE = 'REMOVE_PHONE';
export const REMOVE_ADDRESS = 'REMOVE_ADDRESS';
export const UPDATE_MESSAGE_SUPPRESSION = 'UPDATE_MESSAGE_SUPPRESSION';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const UPDATE_PURCHASER_CONSENT = 'UPDATE_PURCHASER_CONSENT';
export const UPDATE_PROVIDER_TOKEN = 'UPDATE_PROVIDER_TOKEN';
export const UPDATE_USER_ROLES = 'UPDATE_USER_ROLES';
export const UPDATE_USER_ACCOUNT_INFO = 'UPDATE_USER_ACCOUNT_INFO'
export const UPDATE_USERNAME = 'UPDATE_USERNAME'


